import React from 'react';
import PropTypes from 'prop-types';
import { ImpressionProvider, useImpression } from '@thd-olt-component-react/impression';

/**
 * The container the banner reports itself under, provided here so the banner never takes its
 * container from whatever it happens to render inside.
 *
 * `name` and `component` stay alphanumeric: the package strips non-word characters from both.
 */
const CONTAINER = {
  id: 'aiAssistedSearchBanner',
  name: 'AiAssistedSearchBanner',
  component: 'AiAssistedSearchBanner',
  type: 'content',
  position: ''
};

/**
 * Registers the banner with the observer and carries the `clickid`.
 *
 * Separate from `BannerImpression` because `useImpression` reads its container from context, which
 * a component cannot do for a provider it renders itself.
 */
const ImpressedRoot = ({ anchor, variant, children }) => {
  const { ref, clickID } = useImpression({
    data: {
      id: anchor,
      name: 'AiAssistedSearchBanner',
      component: 'AiAssistedSearchBanner',
      type: 'content',
      position: 1,
      variation: variant
    }
  });

  // eslint-disable-next-line react/no-unknown-property
  return <div ref={ref} clickid={clickID}>{children}</div>;
};

ImpressedRoot.displayName = 'ImpressedRoot';

ImpressedRoot.propTypes = {
  anchor: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.node
};

export const BannerImpression = ({ anchor, variant, children }) => (
  <ImpressionProvider data={CONTAINER}>
    <ImpressedRoot anchor={anchor} variant={variant}>
      {children}
    </ImpressedRoot>
  </ImpressionProvider>
);

BannerImpression.displayName = 'BannerImpression';

BannerImpression.propTypes = {
  /** Search term the banner was built for; reported as the impression's `id`. */
  anchor: PropTypes.string,
  /** Config Service variant; reported as the impression's `variation`. */
  variant: PropTypes.string,
  /** The banner layout to impress. */
  children: PropTypes.node
};
